import Vue from 'vue'
import App from './App.vue'
import FastClick from 'fastclick'
import './assets/style.less'
import './assets/fonts/font_tab_bar/iconfont.css'
import './assets/fonts/font_9zfiunq9or/iconfont.css'
import router from './router'
import store from './store'

FastClick.attach(document.body)
Vue.config.productionTip = false
// 支付宝title设置
if (navigator.userAgent.match(/Alipay/i)) {
    window.AlipayJSBridge.call('setTitleColor', {
        color: 16720719,
        reset: false
    })
    window.AlipayJSBridge.call('setTitle', {
        title: '聚惠享'
    })
}
new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')
